import styled from 'styled-components';

export const Container = styled.div`
	margin-bottom: 12px;
`;

export const CardContent = styled.div`
	padding: 8px 12px;
`;

export const ButtonsWrapper = styled.div`
	display: flex;
`;
